import React from 'react';
import { Link } from 'react-router-dom';
import { getExternalDevices } from '~/javascripts/admin/actions/devices';
import { colors } from '~/javascripts/admin/theme';
import { formatDate } from '~/javascripts/admin/utils';
import { createBadge } from '../../atoms/Badge';
import Table from '../../atoms/Table';
import SeqPager from '../../organisms/SeqPager';

type Props = {
  deviceKeys?: Awaited<ReturnType<typeof getExternalDevices>>;
  onChangePage: (paginatedLink: string | null) => void;
};

type Header = {
  label: string;
  size: number;
};

const HEADERS: Header[] = [
  { label: '状態', size: 1 },
  { label: '店舗名（組織名）', size: 4.5 },
  { label: '端末ID', size: 4.5 },
  {
    label: 'SharedKey発行日時',
    size: 3,
  },
];

const DeviceKeyStatusBadge = createBadge({
  active: {
    label: '有効',
    color: colors.white,
    bgColor: colors.green['300'],
  },
  disabled: {
    label: '無効',
    color: colors.white,
    bgColor: colors.gray['300'],
  },
});

const ListTable = ({ deviceKeys, onChangePage }: Props) => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          {HEADERS.map((h) => (
            <Table.Cell size={h.size}>{h.label}</Table.Cell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {deviceKeys?.rows?.map((d) => (
          <Table.Row key={d.terminal_id}>
            <Table.Cell wordBreak="keep-all">
              <DeviceKeyStatusBadge status={d.is_terminal_invalidated ? 'disabled' : 'active'} />
            </Table.Cell>
            <Table.Cell ellipsis>{`${d.shop_name} (${d.organization_name})`}</Table.Cell>
            <Table.Cell ellipsis>
              <Link to={`/settings/device-keys/${d.terminal_id}`}>{d.terminal_id}</Link>
            </Table.Cell>
            <Table.Cell wordBreak="break-word">
              {d.shared_key_created_at ? formatDate(d.shared_key_created_at) : ''}
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row noBorder>
          <Table.Cell colSpan={HEADERS.length} align="center" styles={{ paddingTop: '16px' }}>
            {deviceKeys && (
              <SeqPager prev={deviceKeys.prev} next={deviceKeys.next} onChangePage={onChangePage} />
            )}
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default ListTable;
